<div class="container-fluid">
  <div class="row">
    <div class="col-12" *ngIf="utility.currentActive==1">
      <list-accounts [ctrlData]="ctrlData"></list-accounts>
    </div>
    <div class="col-12" *ngIf="utility.currentActive==2">
      <ca-management [ctrlData]="ctrlData"></ca-management>
      
    </div>
    <div class="col-12" *ngIf="utility.currentActive==3">
      <app-carriercorrespondence [ctrlData]="ctrlData" ></app-carriercorrespondence>
    </div>
    <div class="col-12" *ngIf="utility.currentActive==4">
      <ca-management [ctrlData]="ctrlData"></ca-management>
    </div>
  </div>


</div>

